<template>
  <div class="ds-control ds-myschedule-calendar ds-no-padding">
    <div v-if="isSwitch" class="ds-myschedule-calendar-switch">
      <div class="ds-myschedule-tabs">
        <div
          v-for="(item, index) in scheduleTypeList"
          class="ds-myschedule-tab"
          :key="index"
          :class="{ active: type == item.value }"
          @click="changeType(item)"
        >
          {{ item.text }}
        </div>
      </div>
      <div class="ds-myschedule-calendar-switch-time">
        <i class="iconfont icon-left" @click="switchRange(-1)"></i>
        <el-date-picker
          v-if="datePickerType"
          v-model="pickerValue"
          :editable="false"
          :clearable="false"
          :type="datePickerType"
          :format="datePickerFormat"
          :key="datePickerType"
          size="mini"
          prefix-icon=" "
          value-format="yyyy-MM-dd"
          placeholder="选择周"
        />
        <i class="iconfont icon-right" @click="switchRange(1)"></i>
      </div>
      <div class="ds-myschedule-calendar-switch-btns">
        <DsfButton icon="add" @click="handleAdd">新增日程</DsfButton>
        <DsfButton icon="dingwei" @click="handlerBack">今天</DsfButton>
      </div>
    </div>
    <div
      :class="[
        'ds-myschedule-calendar-body',
        type != 'day' ? 'fixed-head' : '',
      ]"
    >
      <div
        class="ds-myschedule-calendar-table-header-wrap"
        v-show="type != 'day'"
      >
        <table class="ds-myschedule-calendar-table-header">
          <tr>
            <td
              class="ds-myschedule-calendar-table-allday-width"
              v-if="type != 'month'"
            ></td>
            <td
              :class="{
                now: nowDay == week.id,
              }"
              v-for="(week, index) in weeks"
              :key="index"
            >
              {{ week.text }}
              <span class="tag">
                <template v-if="holidayInfo[week.id]">
                  <span class="holiday" :title="getTitle(lunarRange[week.id])" v-if="holidayInfo[week.id].is_work==0">休</span>
                  <span class="workday" :title="getTitle(lunarRange[week.id])" v-if="holidayInfo[week.id].is_work==1">班</span>
                </template>
              </span>
            </td>
          </tr>
        </table>
      </div>
      <!-- 月日历 -->
      <DsfVirtualScroll ref="scroll">
        <div :class="['ds-myschedule-calendar-table-body-wrap', type]">
          <table class="ds-myschedule-calendar-table-body">
            <thead>
              <tr>
                <th
                  class="ds-myschedule-calendar-table-allday-width"
                  v-if="type != 'month'"
                ></th>
                <th v-for="day in weeks" :key="day.id"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="type != 'month'">
                <td
                  class="ds-myschedule-calendar-table-allday-width"
                  style="line-height: 60px"
                >
                  全天
                </td>
                <td
                  class="ds-myschedule-calendar-table-allday-td"
                  :class="{
                    now: nowDay == day.id,
                  }"
                  v-for="day in tableData[0]"
                  :key="day.id"
                >
                  <div v-if="day.id">
                    <template v-if="day.schedule">
                      <template v-for="scheduleItem in day.schedule">
                        <DsfMyScheduleCapsule
                          :key="scheduleItem.id"
                          :schedule="scheduleItem"
                          :editPath="editPath"
                          v-if="scheduleItem.isDay == '1'"
                        ></DsfMyScheduleCapsule>
                      </template>
                    </template>
                  </div>
                </td>
              </tr>
              <tr v-for="(week, index) in tableData" :key="index">
                <!-- 时间刻度 -->
                <td
                  class="
                    ds-myschedule-calendar-table-allday
                    ds-myschedule-calendar-table-allday-width
                  "
                  v-show="type != 'month'"
                >
                  <div
                    class="ds-myschedule-calendar-table-allday-text"
                    v-for="item in hoursList"
                    :key="item.id"
                  >
                    <span>{{ item.text }}</span>
                  </div>
                  <span
                    :style="nowTimeStyle"
                    class="ds-myschedule-calendar-nowtime-time"
                  >
                    {{ nowTime }}
                  </span>
                </td>
                <td
                  :class="{
                    now: nowDay == day.id,
                    holiday: holidayInfo[day.id]&&holidayInfo[day.id].is_work==0,
                    workday: holidayInfo[day.id]&&holidayInfo[day.id].is_work==1,
                  }"
                  v-for="day in week"
                  :key="day.id"
                >
                  <!-- 日历 -->
                  <div
                    v-if="day.id && type == 'month'"
                    class="ds-myschedule-calendar-table-day"
                    :class="{
                      offset: !day.offset,
                    }"
                    @click="active = day.id"
                  >
                    <div
                      class="ds-myschedule-calendar-table-day-day"
                      :title="getTitle(lunarRange[day.id])"
                    >
                      <span class="ds-myschedule-calendar-table-day-num">{{
                        day.day
                      }}</span>
                      <span class="ds-myschedule-calendar-table-day-zhDay">
                        {{getZhDay(day.id)}}
                      </span>
                      <span class="ds-myschedule-calendar-table-tag">
                        <template v-if="holidayInfo[day.id]&&holidayInfo[day.id].is_work==0">休</template>
                        <template v-else-if="holidayInfo[day.id]&&holidayInfo[day.id].is_work==1">班</template>
                      </span>
                    </div>
                    <template v-if="day.schedule">
                      <!-- 日程 -->
                      <template v-for="(scheduleItem, index) in day.schedule">
                        <DsfMyScheduleCapsule
                          :key="scheduleItem.id"
                          :schedule="scheduleItem"
                          :editPath="editPath"
                          v-if="index == 0 || (day.schedule.length == 2 && index == 1)"
                        ></DsfMyScheduleCapsule>
                      </template>
                      <div
                        class="ds-myschedule-calendar-table-day-more"
                        v-if="day.schedule.length > 2"
                        @click="morePlan(day.id)"
                      >
                        更多
                      </div>
                    </template>
                  </div>
                  <!-- 图表 -->
                  <template v-else-if="day.id && type != 'month'">
                    <DsfMyScheduleFigure
                      :edit-path="editPath"
                      :day="day.id"
                      :scheduleList="day.schedule"
                      :now-time="nowTime"
                    ></DsfMyScheduleFigure>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </DsfVirtualScroll>
    </div>
  </div>
</template>

<script>
const oneDay = 86400000;
const oneWeek = 604800000;
const lunarRange = {};
const weeks = [
  {
    key: "1",
    text: "星期一",
  },
  {
    key: "2",
    text: "星期二",
  },
  {
    key: "3",
    text: "星期三",
  },
  {
    key: "4",
    text: "星期四",
  },
  {
    key: "5",
    text: "星期五",
  },
  {
    key: "6",
    text: "星期六",
  },
  {
    key: "0",
    text: "星期日",
  },
];
import DsfMyScheduleCapsule from "./scheduleCapsule";
export default dsf.component({
  name: "DsfMyscheduleCalendar",
  mixins: [$mixins.control],
  ctrlCaption: "个人日程日历",
  design: {
    isMask: false,
  },
  props: {
    holidayUrl: {
      type: String,
      default: "/agenda/info/findHoliday",
    },
    // 是否显示假日
    isShowHoliday: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "/agenda/info/queryFollowAgendaByDate",
    },
    userIds: {
      type: String,
      default: "",
    },
    // 是否允许切换周
    isSwitch: {
      type: Boolean,
      default: true,
    },
    // 是否公开
    isPublicUse: {
      type: Boolean,
      default: false,
    },
    dataLoadedFun: {
      type: Function,
      required: false,
    },
    // 时间
    toDay: {
      type: [String, Date],
      default: null,
    },
    // 展示方式
    // day 日，week 周，month 月
    type: {
      type: String,
      default: "week",
    },
    myTreeNode: {
      type: Object,
      default: () => {
        return { label: "", id: "" };
      },
    },
    // 跳转-新增、查看
    editPath: {
      type: String,
      default: "",
    },
  },
  components: {
    DsfMyScheduleCapsule,
  },
  data() {
    return {
      scheduleTypeList: [
        {
          text: "月",
          value: "month",
        },
        {
          text: "周",
          value: "week",
        },
        {
          text: "日",
          value: "day",
        },
        {
          text: "列",
          value: "list",
        },
      ],
      weeks: weeks,
      pickerValue: "",
      active: null,
      range: [],
      lunarRange: {},
      // 日程信息
      scheduleInfo: {}, // 日程列表（所有）
      scheduleInfoDay: {}, // 日程列表（非全天）
      scheduleInfoAllDay: {}, // 日程列表（全天）
      nowDay: dsf.date.format(new Date(), "yyyy-mm-dd"),
      nowTime: "",
      nowTimeInterval: null,
      hoursList: [],
      holidayInfo: {}, // 假日
    };
  },
  computed: {
    datePickerType: {
      get() {
        return this.type == "day" ? "date" : this.type;
      },
    },
    datePickerFormat: {
      get() {
        if (this.type == "month") {
          return "yyyy年MM月";
        } else if (this.type == "week") {
          return "yyyy年MM月 (第WW周)";
        } else {
          return "yyyy年MM月dd日";
        }
      },
    },
    tableData() {
      let rowNum = 7;
      let { type, range, scheduleInfo, weeks } = this;
      let newRange = [];
      if (type == "week") {
        rowNum = 8;
      } else if (type == "day") {
        rowNum = 2;
      }
      _.each(range, (v, i) => {
        let lineNum = Math.ceil((i + 1) / rowNum);
        if (!newRange[lineNum - 1]) {
          newRange[lineNum - 1] = [];
        }
        v.schedule = scheduleInfo[v.id];
        newRange[lineNum - 1].push(v);
      });
      return newRange;
    },

    nowTimeStyle: {
      get() {
        let nowTime = this.nowTime;
        if (!nowTime) return {};
        let startTime = dsf.date.format(new Date(), "yyyy-mm-dd");
        let timeCha =
          dsf.date.parse(startTime + " " + nowTime).getTime() -
          dsf.date.parse(startTime).getTime();
        return {
          top: (timeCha / 1000 / 60 / 60 / 25) * 100 + "%",
        };
      },
    },
  },
  watch: {
    active(to) {
      if (to) {
        this.$dispatch("change", to);
      }
    },
    url() {
      this.reloadData();
    },
    toDay: {
      handler(to) {
        if (!to) {
          this.pickerValue = dsf.date.format(new Date(), "yyyy-mm-dd");
          this.reloadData();
          return;
        }
        if (dsf.isString(to)) {
          to = dsf.date.parse(to, "yyyy-mm-dd");
        }
        if (dsf.type(to) !== "date") {
          to = new Date();
        }
        this.pickerValue = dsf.date.format(to, "yyyy-mm-dd");
        this.reloadData();
      },
      immediate: true,
    },
    pickerValue() {
      this.reloadData();
    },
  },
  created() {
    // 时间刻度线
    var hoursList = [];
    for (var i = 0; i < 25; i++) {
      hoursList.push({
        id: ("0" + i).slice(-2),
        text: ("0" + i).slice(-2) + ":00",
      });
    }
    this.hoursList = hoursList;

    // 农历
    this.loadScript(() => {
      this.setLunarRange();
    });

    // 当前时间刻度线
    this.getNowTime();
    this.nowTimeInterval = setInterval(() => {
      this.getNowTime();
    }, 60 * 1000);
  },
  beforeDestroy() {
    this.nowTimeInterval = null;
  },
  methods: {
    // 切换显示范围
    switchRange(n) {
      if (!n) return;
      if (this.type === "week") {
        this.switchWeek(n);
      } else if (this.type === "week2") {
        this.switchWeek(n * 2);
      } else if (this.type === "month") {
        this.switchMonth(n);
      } else if (this.type == "day") {
        this.switchDay(n);
      }
    },
    // 切换周
    switchWeek(n) {
      let to = dsf.date.parse(this.pickerValue, "yyyy-mm-dd");
      to = new Date(to.getTime() + n * oneWeek);
      this.pickerValue = dsf.date.format(to, "yyyy-mm-dd");
    },
    // 切换月
    switchMonth(n) {
      let to = dsf.date.parse(this.pickerValue, "yyyy-mm-dd");
      to.setDate(0);
      to = new Date(to.getTime() + (n * 4 + 2) * oneWeek);
      this.pickerValue = dsf.date.format(to, "yyyy-mm-01");
    },
    // 切换日
    switchDay(n) {
      let to = dsf.date.parse(this.pickerValue, "yyyy-mm-dd");
      to = new Date(to.getTime() + n * oneDay);
      this.pickerValue = dsf.date.format(to, "yyyy-mm-dd");
    },
    // 显示农历号/节日
    getZhDay(dayId) {
      let day=this.lunarRange[dayId]
      if (!day) {
        return "";
      }
      if(this.holidayInfo[dayId]?.holidayFirst){
        return this.holidayInfo[dayId]?.holidayFirst
      }
      return day.jieRi.length ? day.jieRi[0] : day.lunarJieQi || day.lunarDay;
    },
    // 提示信息(农历)
    getTitle(info) {
      if (!info) return "";
      let {
        day,
        lunarYear,
        lunarMonth,
        lunarDay,
        lunarJieQi,
        jieRi,
        otherJieRi,
        dayId,
      } = info;
      if (this.holidayInfo[dayId]) {
        return this.holidayInfo[dayId]?.holidayArr?.join("\n");
      }
      let res = [day, `农历${lunarYear}年${lunarMonth}月${lunarDay}`];
      if (lunarJieQi) res.push(`节气：${lunarJieQi}`);
      let jr = [...jieRi, ...otherJieRi];
      if (jr.length) res.push(`今天是${jr.join("、")}。`);
      return res.join("\n");
    },

    // 日程提示信息
    getScheduleTitle(schedule) {
      if (!schedule) return "";
      let { endTime, startTime, theme, curUserName, addressText } = schedule;
      let res = [curUserName, theme, startTime + " - " + endTime, addressText];
      return res.join("\n");
    },
    // 加载农历插件
    loadScript(callback) {
      this.$http
        .importFiles(dsf.url.getWebPath("$/js/libs/lunar/lunarDay.js"))
        .then(([{ state }]) => {
          if (state) {
            callback?.();
          } else {
            dsf.error("加载lunarDay.js文件出错");
          }
        })
        .catch((err) => {
          dsf.error(err);
        });
    },
    reloadData() {
      this.scheduleInfo = {};
      let toDay = dsf.date.parse(this.pickerValue, "yyyy-mm-dd");
      toDay = toDay?.getTime() || dsf.date.toDay();
      let { range, active } = this.getRange(toDay);
      this.range = range;
      this.active = active;
      let endDate = dsf.date.format(
        new Date(range[range.length - 1].date.getTime() + oneDay),
        "yyyy-mm-dd"
      );
      if (this.type == "month") {
        this.weeks = weeks;
      } else if (this.type == "week") {
        let _weeks = [];
        _.each(weeks, (item) => {
          let id = range.find((it) => {
            return it.weekNum == item.key;
          }).id;
          _weeks.push({
            key: item.key,
            text: `${item.text} ${id.slice(5, 7)}/${id.slice(-2)}`,
            id: id,
          });
        });
        this.weeks = _weeks;
      } else if (this.type == "day") {
        this.weeks = [{ key: new Date(this.pickerValue).getDay(), text: "" }];
      }
      if (!this.isDesign) {
        this.getScheduleInfo(range[0].id, endDate);
        this.getHolidayInfo(range[0].id, endDate);
      }
      this.setLunarRange();
    },
    // 计算时间范围
    getRange(day = dsf.date.toDay()) {
      let current = new Date(day);
      let month = current.getMonth();
      let type = this.type;
      let isMonth = type === "month";
      if (isMonth) {
        day = current.setDate(1);
      }
      let range = [];
      let toDay = dsf.date.toDay(),
        active = null;
      let week = current.getDay() || 7;
      let l = 7 - week;
      if (type === "week2") {
        l += 7;
      } else if (isMonth) {
        l += 35;
      }

      if (type != "day") {
        for (let i = 1 - week; i <= l; i++) {
          let t = day + oneDay * i;
          let d = new Date(t);
          let dd = d.getDate();
          let item = {
            id: dsf.date.format(d, "yyyy-mm-dd"),
            offset: !isMonth || d.getMonth() === month,
            // day: dd < 10 ? "0" + dd : dd,
            day: dd,
            date: d,
            weekNum: d.getDay(),
          };
          range.push(item);
          if (t == toDay) {
            active = item;
          }
        }
      } else {
        range = [
          {
            id: dsf.date.format(current, "yyyy-mm-dd"),
            offset: !isMonth || current.getMonth() === month,
            day: current.getDate(),
            date: current,
            weekNum: current.getDay(),
          },
        ];
      }
      if (!active) {
        active = range[0];
      }
      return { range, active };
    },
    // 计算农历信息
    setLunarRange() {
      if (!window.Solar) return;
      let newRange = {};
      _.forEach(this.range, ({ id, date }) => {
        if (!lunarRange[id]) {
          let solar = window.Solar.fromDate(date);
          let lunar = solar.getLunar();
          lunarRange[id] = {
            dayId: id,
            day: dsf.date.format(date, "yyyy年mm月dd日"),
            lunarYear: lunar.getYearInGanZhi(),
            lunarMonth: lunar.getMonthInChinese(),
            lunarDay: lunar.getDayInChinese(),
            lunarJieQi: lunar.getJieQi(),
            jieRi: [...lunar.getFestivals(), ...solar.getFestivals()],
            otherJieRi: solar.getOtherFestivals(),
          };
        }
        newRange[id] = lunarRange[id];
      });
      this.lunarRange = newRange;
    },
    // 获取日程信息
    getScheduleInfo(startDate, endDate) {
      if (!this.url || this.url == "") {
        this.scheduleInfo = {};
        return;
      }
      let isSelf = 1;
      let userIds = this.userIds;
      // 如果选中有自己 isSelft传1 否者0
      if (userIds.indexOf(this.myTreeNode.id) != -1) {
        userIds = userIds.slice(this.myTreeNode.id.length + 1);
      } else {
        isSelf = 0;
      }
      // 不公开话 只查自己 isSelf传1
      if (!this.isPublicUse) {
        isSelf = 1;
      }
      // 间距
      let params = {
        startDate: startDate,
        endDate: endDate,
        categoryValue: 0, // 0 个人日程；1 领导日程
        isSelf,
        userIds,
      };
      this.$http
        .get(this.url, params)
        .done(({ success, data, message }) => {
          if (success) {
            let scheduleInfoDay = {};
            let scheduleInfoAllDay = {};
            _.forIn(data, (dayPlans, day) => {
              if (dayPlans?.length > 0) {
                let _dayPlansDay = []; // 不含全天
                let _dayPlansAllDay = []; // 全天
                _.each(dayPlans, (schedule) => {
                  if (schedule?.isDay == "1") {
                    _dayPlansAllDay.push(schedule);
                  } else {
                    _dayPlansDay.push(schedule);
                  }
                });
                scheduleInfoDay[day] = _dayPlansDay;
                scheduleInfoAllDay[day] = _dayPlansAllDay;
              }
            });
            this.scheduleInfo = data;
            this.scheduleInfoDay = scheduleInfoDay;
            this.scheduleInfoAllDay = scheduleInfoAllDay;
            this.dataLoadedFun?.(data, this);
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },

    // 获取假日信息
    getHolidayInfo(startDate, endDate) {
      if (!this.isShowHoliday || !this.holidayUrl || this.holidayUrl == "") {
        this.holidayInfo = {};
        return;
      }

      // 间距
      let params = {
        beginTime: startDate,
        endTime: endDate,
      };
      this.$http
        .get(this.holidayUrl, params)
        .done(({ success, data, message }) => {
          if (success) {
            let holidayInfo = {};
            _.forEach(data, (item) => {
              let dayId = item.time?.slice(0, 10);
              holidayInfo[dayId] = _.cloneDeep(item);
              holidayInfo[dayId].holidayArr = item.type_text?.split("^");
              holidayInfo[dayId].holidayFirst = item.type_text?holidayInfo[dayId]?.holidayArr[0]:"";
            });
            this.holidayInfo = holidayInfo;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },

    // 点击返回今日
    handlerBack() {
      this.pickerValue = this.nowDay;
    },
    changeType(e) {
      this.$emit("changeType", e);
    },

    morePlan(dayId) {
      this.pickerValue = dayId;
      this.$emit("changeType", { text: "日", value: "day" });
    },
    handleAdd() {
      this.$openDialog({
        title: "新增日程",
        width: "80%",
        height: "70vh",
        params: {
          path: this.$replace(this.editPath),
        },
      });
    },
    getNowTime() {
      let time = new Date();
      this.nowTime =
        ("0" + time.getHours()).slice(-2) +
        ":" +
        ("0" + time.getMinutes()).slice(-2);
    },
  },
});
</script>
